import { Alert, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const AlertStyled = styled(Alert)`
  margin-top: 4rem;
  border: 1px solid ${colors.red[300]};
`;
